import React from 'react';
import { useNavigate } from 'react-router-dom';
import './style.css';
import {useAuth} from "../../../context/AuthContext";

const UnauthorizedPage = () => {
    const navigate = useNavigate();
    const {user} = useAuth();
    return (
        <>
            <div className="container">
                <h1 className="heading">401</h1>
                <p className="paragraph">غير مصرح لك بالوصول إلى هذه الصفحة</p>
                <button className="button btn filled" onClick={()=>navigate(`/${user.role}`)}>
                    العودة إلى الصفحة الرئيسية
                </button>
            </div>
        </>
    );
};

export default UnauthorizedPage;
